import { render, staticRenderFns } from "./HormonalTreatmentPart.vue?vue&type=template&id=18802b27&scoped=true&"
import script from "./HormonalTreatmentPart.ts?vue&type=script&lang=ts&"
export * from "./HormonalTreatmentPart.ts?vue&type=script&lang=ts&"
import style0 from "./HormonalTreatmentPart.scss?vue&type=style&index=0&id=18802b27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18802b27",
  null
  
)

export default component.exports